import "./FMMedicalHistoryReview.scss";

import cx from "classnames";
import { useSelector } from "utils/redux";

import MedicalRecordTable from "./medical-records/MedicalRecordTable";
import type { MedicalHistoryTableProps } from "./medicalRecordUtils";
import PayHistoryTable from "./pay-history/PayHistoryTable";

const FutureMedicalMedicalHistoryReview = ({
  service,
}: MedicalHistoryTableProps) => {
  const showMedicalHistory = useSelector(
    (state) => state.drawer.showMedicalHistory,
  );

  return (
    <div
      className={cx("documents documents-msa flex jc-se", {
        open: showMedicalHistory,
      })}
    >
      <div className="documents-wrapper overflow-hidden">
        <div className="swim-wrapper h-100">
          <div className="grid-layout gl-2 no-gap-tb swimlanes msa">
            {/* Left Column - Pay History */}
            <div className="swim-column">
              <PayHistoryTable service={service} />
            </div>

            {/* Right Column - Medical Record Review */}
            <div className="swim-column">
              <MedicalRecordTable service={service} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FutureMedicalMedicalHistoryReview;
